import { FaCheckCircle, FaShoppingCart } from 'react-icons/fa';
import { MdOutlineAttachMoney } from 'react-icons/md';

import { Step, StepperFabric } from '@/resources/components/stepper/StepperFabric';
import { useDevice } from '@/resources/hooks/useDevice';

export function CartContextStepper({
  choosenStep,
}: {
  choosenStep: 'cart' | 'checkout' | 'finished';
}) {
  const { device } = useDevice();

  const cartSteps = {
    cart: 1,
    checkout: 2,
    finished: 3,
  };

  const isMobile = device === 'mobile';
  const iconSize = isMobile ? '1.5rem' : '2rem';
  const circleSize = isMobile ? '3rem' : '3.5rem';
  const blueColor = '#17A2B8';
  const grayColor = '#989898';
  const whiteColor = '#ffffff';

  const margins = isMobile ? 'ml-4 mr-4' : 'ml-4 mr-5';

  const currentStepNumber = cartSteps[choosenStep];

  const getStepStyle = (stepNumber: number) => {
    if (stepNumber === currentStepNumber) {
      return {
        backgroundColor: blueColor,
        borderColor: blueColor,
        iconColor: whiteColor,
        titleColor: blueColor,
      };
    }
    if (stepNumber < currentStepNumber) {
      return {
        backgroundColor: whiteColor,
        borderColor: blueColor,
        iconColor: blueColor,
        titleColor: blueColor,
      };
    }
    return {
      backgroundColor: whiteColor,
      borderColor: grayColor,
      iconColor: grayColor,
      titleColor: grayColor,
    };
  };

  const steps: Step[] = [
    {
      title: 'Carrinho',
      icon: (color: string) => <FaShoppingCart fill={color} size={iconSize} />,
      itemContentProps: {
        style: {
          paddingLeft: isMobile ? '14%' : '15%',
          fontSize: '0.875rem',
          color: getStepStyle(1).titleColor,
        },
      },
      indicatorProps: { className: margins },
      circleProps: {
        style: {
          width: circleSize,
          height: circleSize,
          borderColor: getStepStyle(1).borderColor,
          backgroundColor: getStepStyle(1).backgroundColor,
        },
      },
      progressProps: {
        color: currentStepNumber === 2 ? blueColor : grayColor,
      },
      step: 1,
    },
    {
      title: 'Pagamento',
      icon: (color: string) => <MdOutlineAttachMoney color={color} size={iconSize} />,
      itemContentProps: {
        style: {
          paddingLeft: '7%',
          fontSize: '0.875rem',
          color: getStepStyle(2).titleColor,
        },
      },
      indicatorProps: { className: margins },
      circleProps: {
        style: {
          width: circleSize,
          height: circleSize,
          borderColor: getStepStyle(2).borderColor,
          backgroundColor: getStepStyle(2).backgroundColor,
        },
      },
      progressProps: {
        color: currentStepNumber === 3 ? blueColor : grayColor,
      },
      step: 2,
    },
    {
      title: 'Concluído',
      icon: (color: string) => <FaCheckCircle color={color} size={iconSize} />,
      indicatorProps: { className: margins },
      itemContentProps: {
        style: {
          paddingLeft: isMobile ? '14%' : '15%',
          fontSize: '0.875rem',
          color: getStepStyle(3).titleColor,
        },
      },
      circleProps: {
        style: {
          width: circleSize,
          height: circleSize,
          borderColor: getStepStyle(3).borderColor,
          backgroundColor: getStepStyle(3).backgroundColor,
        },
      },
      step: 3,
    },
  ];

  return (
    <StepperFabric
      orientation="horizontal"
      steps={steps.map((step) => ({
        ...step,
        icon:
          typeof step.icon === 'function'
            ? step.icon(getStepStyle(step.step).iconColor)
            : step.icon,
      }))}
    />
  );
}
